sn-hero-header-type-4 {
  .sn-hero-header-type-4 {
    position: relative;
    padding-top: px-to-rem(40px);
    padding-bottom: px-to-rem(80px);

    @include desktop {
      padding-top: px-to-rem(104px);
      padding-bottom: px-to-rem(104px);
    }

    @include above(960px) {
      padding-top: px-to-rem(100px);
      padding-bottom: px-to-rem(100px);
    }

    @include above(1200px) {
      padding-top: px-to-rem(122px);
      padding-bottom: px-to-rem(100px);
    }
  }

  .sn-hero-header-type-4__container {
    max-width: $sn-container-max-width;
    margin: 0 auto;
    padding: 0 px-to-rem(16px);

    @include desktop {
      padding: 0 px-to-rem(24px);
    }
  }

  .sn-hero-header-type-4__row {
    @include above(960px) {
      display: flex;
      align-items: flex-start;
    }
  }

  // ── Left column (details) ────────────────────────────────────────
  .sn-hero-header-type-4__column--details {
    text-align: center;

    @include above(960px) {
      flex-shrink: 0;
      width: px-to-rem(451px);
      text-align: left;
      margin-right: px-to-rem(49px);
    }

    @include above(1200px) {
      width: px-to-rem(533px);
      margin-right: px-to-rem(111px);
    }

    .me-heading {
      font-size: px-to-rem(28px);
      line-height: px-to-rem(40px);
      margin-top: 0;
      margin-bottom: px-to-rem(12px);

      @include desktop {
        font-size: px-to-rem(36px);
        line-height: px-to-rem(48px);
        margin-bottom: px-to-rem(16px);
      }

      @include above(960px) {
        text-align: left;
        font-size: px-to-rem(40px);
      }

      @include above(1200px) {
        font-size: px-to-rem(52px);
        line-height: px-to-rem(64px);
        margin-bottom: px-to-rem(20px);
      }
    }

    me-text {
      display: block;
      font-size: px-to-rem(14px);
      line-height: px-to-rem(20px);
      margin-bottom: px-to-rem(24px);

      @include desktop {
        font-size: px-to-rem(16px);
        line-height: px-to-rem(24px);
        margin-bottom: px-to-rem(22px);
      }

      @include above(1200px) {
        font-size: px-to-rem(20px);
        line-height: px-to-rem(28px);
        margin-bottom: px-to-rem(50px);
      }
    }
  }

  // ── Right column (form) ──────────────────────────────────────────
  .sn-hero-header-type-4__column--form {
    display: flex;
    justify-content: center;

    @include above(960px) {
      flex: 1;
      display: block;
    }
  }

  // ── Benefits checklist ───────────────────────────────────────────
  .sn-hero-header-type-4__benefits {
    margin-bottom: px-to-rem(22px);
    text-align: left;

    @include desktop {
      margin-bottom: px-to-rem(106px);
    }

    @include above(960px) {
      margin-bottom: px-to-rem(4px);
    }

    .me-list {
      gap: px-to-rem(10px) px-to-rem(13px);

      @include above(960px) {
        gap: px-to-rem(12px) px-to-rem(20px);
      }
    }

    .me-list__item {
      position: relative;
      font-weight: 700;
      font-size: px-to-rem(14px);
      line-height: px-to-rem(24px);
      padding-left: px-to-rem(29px);

      @include above(960px) {
        font-size: px-to-rem(20px);
        padding-left: px-to-rem(40px);
        line-height: px-to-rem(28px);
      }

      .me-list__icon {
        display: none;
      }

      &::before {
        position: absolute;
        content: '';
        left: 0;

        // Green circle checkmark
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='25' fill='none' viewBox='0 0 24 25'%3E%3Cpath fill='%2300c6b1' fill-rule='evenodd' d='M12 24.5c-6.628 0-12-5.372-12-12S5.372.5 12 .5s12 5.372 12 12-5.372 12-12 12' clip-rule='evenodd'/%3E%3Cpath stroke='%23fff' stroke-linecap='round' stroke-width='2' d='M17.333 9.833 10.667 16.5l-4-4'/%3E%3C/svg%3E");
        background-size: contain;
        background-repeat: no-repeat;
        width: px-to-rem(18px);
        height: px-to-rem(18px);
        top: px-to-rem(3px);

        @include above(960px) {
          width: px-to-rem(24px);
          height: px-to-rem(25px);
          top: px-to-rem(2px);
        }
      }
    }
  }

  // ── Form wrapper card ─────────────────────────────────────────────
  .sn-hero-header-type-4__form-wrapper {
    display: block;
    width: 100%;
    position: relative;
    background: var(--background-color-primary);
    box-shadow: 0 5px 25px 0 rgb(0 0 0 / 10%);
    padding: px-to-rem(36px) px-to-rem(16px) px-to-rem(32px);
    margin: 0 px-to-rem(-16px) px-to-rem(34px);

    @include desktop {
      border-radius: var(--radius-size-md);
      margin: 0 auto px-to-rem(56px);
      padding: px-to-rem(40px) px-to-rem(36px);
    }

    @include above(960px) {
      padding: px-to-rem(40px);
      box-shadow: 0 15px 25px 0 rgb(0 0 0 / 10%);
      margin: 0;
    }

    @include above(1200px) {
      box-shadow: 0 20px 80px 0 rgb(0 0 0 / 10%);
      top: px-to-rem(-22px);
      padding: px-to-rem(44px) px-to-rem(52px);
    }

    // Rotated #D5E6FF block behind the white card.
    // z-index:-1 without isolation pushes it behind form-wrapper in the parent stacking context;
    // background:#fff on the card makes the white surface paint over the blue where they overlap,
    // leaving only the rotated corners/edges of the blue block visible around the card.
    &::after {
      @include desktop {
        position: absolute;
        content: '';
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: var(--sn-hero-header-type-4-decoration-color, #d5e6ff);
        border-radius: var(--radius-size-lg);
        transform: rotate(7deg);
        z-index: -1;
      }
    }

    // Decorative SVG ornament (hidden on mobile, shown from tablet+)
    &::before {
      position: absolute;
      content: '';
      right: px-to-rem(-53px);
      display: none;

      // Squiggle SVG ornament from source form-wrapper::before
      background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='161' height='215' fill='none' viewBox='0 0 161 215'%3E%3Cpath fill='%23100419' fill-rule='evenodd' d='M24.461 26.709q-10.367 5.77-21.475 13.268l1.12 1.657q11.073-7.476 21.386-13.21zm11.688-3.846c24.662-11.99 45.777-15.9 63.333-11.766 19.063 4.488 35.166 24.284 39.8 47.048 3.192 15.68.834 33.487-5.343 47.104-5.537 12.208-11.727 22.778-18.086 31.672-2.222 3.11-4.306 5.786-6.191 8.026a78 78 0 0 1-1.748 2.011q-.453.499-.609.658l1.439 1.39q.179-.183.653-.707a77 77 0 0 0 1.795-2.064c1.918-2.279 4.034-4.998 6.288-8.15 6.432-8.998 12.687-19.679 18.281-32.009 6.346-13.99 8.759-32.223 5.481-48.33-4.779-23.473-21.405-43.911-41.301-48.596-18.094-4.26-39.699-.252-64.826 11.992z' clip-rule='evenodd'/%3E%3Cpath fill='%23009c80' d='m53.94 211.204 30.446-56.14 8.222 15.776 29.921-2.556z'/%3E%3Cmask id='a' width='70' height='57' x='53' y='155' maskUnits='userSpaceOnUse' style='mask-type:alpha'%3E%3Cpath fill='%23fff' d='m53.94 211.204 30.446-56.14 8.222 15.776 29.921-2.556z'/%3E%3C/mask%3E%3Cg mask='url(%23a)'%3E%3Cpath stroke='%23d0f4ee' stroke-width='2' d='M107.814 180.095c-10.257 8.972-51.479-18.898-58.21-32.832-6.73-13.935 16.068-17.955 31.963-11.207 12.715 5.398 23.437 17.09 27.591 22.194 29.385 38.44-18.368 50.715-34.948 43.513-13.057-5.672-24.773-33.304-15.619-45.493s14.153 1.792 29.9 5.624c13.385 3.258 24.725 26.382 24.393 33.05-.331 6.667-20.77 24.325-28.492 1.894s-28.49-30.18-35.565-19.019 11.637 22.484 12.21 34.279-18.675 9.252-19.256-19.683c-.029-3.709 1.552-10.62 8.105-8.592 8.19 2.535-13.957 11.216-15.658 19.474s4.935 19.026 12.59 17.677'/%3E%3C/g%3E%3C/svg%3E")
        no-repeat;
      background-size: contain;

      @include desktop {
        display: block;
        width: px-to-rem(134px);
        height: px-to-rem(179px);
        top: px-to-rem(-37px);
        right: px-to-rem(-70px);
      }

      @include above(960px) {
        width: px-to-rem(99px);
        height: px-to-rem(145px);
        right: px-to-rem(-40px);
      }

      @include above(1200px) {
        width: px-to-rem(161px);
        height: px-to-rem(215px);
        right: px-to-rem(-90px);
        top: px-to-rem(-62px);
      }
    }

    // ── Optional form heading (e.g. "Talk to Sales") ────────────────
    .sn-hero-header-type-4__form-heading {
      &:empty {
        display: none;
      }

      me-heading {
        display: block;
        text-align: center;
        font-size: px-to-rem(28px);
        line-height: px-to-rem(36px);
        font-weight: 700;
        margin: 0 0 px-to-rem(16px);

        @include desktop {
          font-size: px-to-rem(32px);
          line-height: px-to-rem(40px);
        }
      }
    }

    // ── Optional "mandatory fields" note ────────────────────────────
    .sn-hero-header-type-4__form-notice {
      &:empty {
        display: none;
      }

      font-size: px-to-rem(12px);
      line-height: px-to-rem(16px);
      color: var(--color-text-secondary, #666);
      margin-bottom: px-to-rem(16px);

      me-text {
        display: block;
      }
    }

    me-input,
    me-select {
      display: block;
      margin-bottom: px-to-rem(17px);

      @include desktop {
        margin-bottom: px-to-rem(20px);
      }
    }

    .sn-hero-header-type-4__form-row {
      display: flex;
      gap: px-to-rem(12px);
      margin-bottom: px-to-rem(17px);

      @include desktop {
        margin-bottom: px-to-rem(20px);
      }

      me-input,
      me-select {
        flex: 1 1 0;
        min-width: 0;
        margin-bottom: 0;
      }
    }

    me-button {
      display: block;
      width: 100%;
      margin-bottom: px-to-rem(16px);

      .me-button {
        width: 100%;
      }
    }

    .sn-hero-header-type-4__agreement-note {
      display: block;
      font-size: px-to-rem(12px);
      line-height: px-to-rem(16px);
      color: var(--color-text-secondary, #666);
      margin-bottom: 0;

      a {
        color: var(--text-color-brand-primary);
        text-decoration: underline;

        &:hover {
          color: #008bf8;
        }
      }
    }
  }
}
